module.exports = __webpack_public_path__ + "static/media/car_accident.1684b50d.jpg";